import { ChangeEvent } from "react";
import MpNumberTextField from "src/components/MpTextFieldNumberOnly";
import { useTranslation } from "src/hooks";
import { useBatchContractSweepFormContext } from "../../../contexts";

function ThresholdNumberTextField({
  value,
  onChange,
}: {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}) {
  const { translate: t } = useBatchContractSweepFormContext();

  const { tc } = useTranslation("common");
  const label = t("threshold");

  return (
    <>
      <div>{label}</div>
      <MpNumberTextField
        value={value}
        label={tc("phInputField", { fieldName: label })}
        onChange={onChange}
      />
    </>
  );
}

export default ThresholdNumberTextField;
